import { WithScope } from '@mews-commander/types';
import { Button, Stack, StackItem } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { isEmptyRecord } from '@mews/fp';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import EnterpriseBuilderScreenStep from '../../EnterpriseBuilderScreenStep';
import { changeStep } from '../../actions/steps';
import { getCategories } from '../../selectors/categories';
import Categories from './Categories';

export const CategoriesView = ({ scope }: WithScope) => {
    const dispatch = useCommanderThunkDispatch();
    const categories = useCommanderSelector(getCategories);

    return (
        <Stack spacing="100" vertical>
            <Categories scope={scope} />
            <StackItem>
                {isEmptyRecord(categories) && (
                    <Button onClick={() => dispatch(changeStep(EnterpriseBuilderScreenStep.Floors))} type="button">
                        {lt('SkipSpaceCategories')}
                    </Button>
                )}
            </StackItem>
        </Stack>
    );
};
